import { useIdentityStore } from '@/stores/identity';
import {
  browserStorageGetSessionItem,
  browserStorageRemoveSessionItem,
} from '@/utils/browserStorage';

export const AFTER_LOGIN_NEXT_KEY = 'afterLoginNext';

function getNext() {
  const sessionStorageNext = browserStorageGetSessionItem(AFTER_LOGIN_NEXT_KEY);
  if (sessionStorageNext) {
    browserStorageRemoveSessionItem(AFTER_LOGIN_NEXT_KEY);
    return sessionStorageNext;
  }
  return { name: 'landingPage' };
}

export function loginRedirect(router) {
  if (!router) {
    return;
  }

  const identityStore = useIdentityStore();
  if (identityStore.identity?.invitation_status === 'accepted') {
    router.push({ name: 'account.setup' });
  } else {
    const next = getNext();
    router.push(next);
  }
}
